import React from 'react'
import { Box, Typography } from '@mui/material'
import TokTokDocDialog from '../../../Common/Dialog'
import { HistoryRowDetailType, PatientFormModificationsHistoryRowDialogProps } from './_props'
import { capitalizeFirstLetter } from '../../../../utils/stringUtils'
import { getDetailType } from './_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

const readValue = (type: HistoryRowDetailType | undefined, value?: string) => {
    if (!value) return undefined
    if (!type) return value

    if (type === 'identityInformation') {
        const items = value.split(',')
        const filtered = items.filter((item) => {
            const splited = item.split(':')

            if (splited[1].trim()) {
                return item
            }
            return undefined
        })

        return filtered
    }

    try {
        return JSON.parse(value).map((x: string) => JSON.parse(x))
    } catch (error) {
        return value
    }
}

// val is never, no types can be provided fo the INSi connector
const renderValue = (type: HistoryRowDetailType | undefined, value: never[]) => {
    if (type === 'identityInformation') {
        return value.map((i: string) => <Typography key={i}>{capitalizeFirstLetter(i)}</Typography>)
    }

    if (type === 'history') {
        return value.map((i: string[]) => (
            <Box
                sx={{
                    padding: '.5rem',
                    borderBottom: `1px solid ${defaultPalette.lightGrey.dark}`,
                }}
            >
                {i.map((ii: string) => (
                    <Typography key={ii}>{capitalizeFirstLetter(ii)}</Typography>
                ))}
            </Box>
        ))
    }

    return <Typography>{value}</Typography>
}

const PatientFormModificationsHistoryRowDialog: React.FC<PatientFormModificationsHistoryRowDialogProps> = ({
    open,
    onClose,
    item,
}) => {
    const type = getDetailType(item?.label ?? '')
    const value = readValue(type, item?.value)

    return (
        <TokTokDocDialog
            isOpen={open}
            handleClose={onClose}
            title={item?.label ? capitalizeFirstLetter(item.label) : undefined}
        >
            {value && renderValue(type, value)}
        </TokTokDocDialog>
    )
}

export default PatientFormModificationsHistoryRowDialog
